export default {
    chart:{
      type: 'areaspline',
      backgroundColor:'transparent',
      height:266,
    },
    title: {
      text: ''
    },
    xAxis: {
      labels:{
        enabled: false
      },
      tickLength:0,
      gridLineWidth: 1,
      gridLineColor:'#DDD9F9'
    }, 
    yAxis: {
      gridLineColor:'#DDD9F9',
      labels:{
        enabled: false
      },
      tickLength:0,
      title: {
        text: ''
      },
    },
    plotOptions:{
      areaspline: {
        dataLabels: {
            enabled: true,
            style: {
              color:'#141721',
              fontSize:'14px',
              fontWeight:'bold',
              textOutline:'none'
            }
        },
        enableMouseTracking: false
      },
      series: {
        color: '#3868F8',
        lineWidth:3,
        fillColor: {
            linearGradient: [0, 0, 0, 300],
            stops: [
                [0, 'rgba(72, 118, 255, 0.5)'],
                [1, 'rgba(72, 118, 255, 0)']
            ]
        }
      }
    },
    series: [{
      data: null,
      showInLegend: false
    }]
}